import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 text-base font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0D3B66]';
  const variants = {
    primary: 'bg-[#0D3B66] text-white hover:bg-[#0A2F52] shadow-md hover:shadow-lg',
    secondary: 'bg-[#E0435A] text-white hover:bg-[#C73A4E] shadow-md',
    outline: 'border-2 border-[#0D3B66] text-[#0D3B66] hover:bg-[#0D3B66] hover:text-white'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-235">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-236" />}
    </button>;
}